import Package from "@/components/colis/Colis";
import ProductColisScanner from "@/components/colis/ProductColisScanner";
import CanceledReturnConfirmationDialog from "@/components/dialogs/CanceledReturnConfirmationDialog";
import ActionButton from "@/components/loader-button/ActionButton";
import { NavigationRoutes } from "@/components/navigation/constants";
import ReturnHeader from "@/components/return/ReturnHeader";
import { ScrollArea } from "@/components/ui/scroll-area";
import { Toaster } from "@/components/ui/toaster";
import { Roles } from "@/enums";
import { Colis } from "@/interfaces/Return";
import { RootState } from "@/store/store";
import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";

const ReturnDetailsPage: React.FC = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const [isOpened, setIsOpened] = useState(false);
  const [validColis, setValidColis] = useState<Colis[]>([]);
  const { toValidate, readOnly } = (location.state ?? {
    toValidate: false,
    readOnly: false,
  }) as {
    toValidate: boolean;
    readOnly: boolean;
  };
  const roles = useSelector((state: RootState) => state.authentication.roles);
  const return_ = useSelector((state: RootState) => state.return.return);
  const handleNavigateToPJPage = () => {
    navigate(NavigationRoutes.PJ);
  };

  const handleConfirmReception = () => {
    setIsOpened(true);
  };

  const handleHUBCheck = () => {
      //annulation_vendeur && recu_provisoire
    return (
      (return_.statutId === 8 && roles.includes(Roles.WAREHOUSE_ROLE))  ||
      return_.statutId === 10 || return_.statutId === 12
    );
  };




  const confirmButtonDisabledCheck = () => {
    return validColis.length !== return_.colis.length;
  };

  useEffect(() => {
    if (return_.numTournee === null || return_.numTournee === undefined) {
      navigate(NavigationRoutes.DASHBOARD);
    }
  }, []);

  return (
    <>
      <ReturnHeader return_={return_} />
      {readOnly || !handleHUBCheck() ? (
        <ScrollArea className="flex-1 flex-grow" showScrollIndicator>
          {return_.colis &&
            return_.colis.map((colis, index) => (
              <Package key={index} colis={colis} />
            ))}
        </ScrollArea>
      ) : (
        <>
          <ProductColisScanner
            colis={return_.colis}
            setValidColis={setValidColis}
          />
          <div className="px-4">
            <ActionButton
              label="Confirmer"
              disabled={confirmButtonDisabledCheck()}
              handleClick={handleConfirmReception}
              loading={false}
            />
          </div>
        </>
      )}
      {!readOnly && toValidate && (
        <div className="px-4">
          <ActionButton
            label="Suivant"
            disabled={false}
            handleClick={handleNavigateToPJPage}
            loading={false}
          />
        </div>
      )}
      {!readOnly && (
        <CanceledReturnConfirmationDialog
          isOpened={isOpened}
          setIsOpened={setIsOpened}
          validColis={validColis}
          returnNumber={return_.numTournee ? return_.numTournee.toString() : ""}
        />
      )}
      <Toaster />
    </>
  );
};

export default ReturnDetailsPage;
